import docImg1 from "../assets/img/deviceDoc_imgs/device1.png";
import register from "../assets/img/deviceDoc_imgs/register.png";
import smrz from "../assets/img/deviceDoc_imgs/smrz.png";
import auth from "../assets/img/deviceDoc_imgs/auth.png";
import docImg11 from "../assets/img/deviceDoc_imgs/1.png";
import docImg12 from "../assets/img/deviceDoc_imgs/2.png";
import docImg13 from "../assets/img/deviceDoc_imgs/3.png";

export const deviceDoc = [
  {
    id: 1,
    label: "新手指引",
    children: [
      {
        id: 11,
        label: "概述",
        path: "/device/overview",
        data: `
# __概述__

本文介绍如何将手表接入到OpenHarmony智能穿戴聚合平台上，包括手机与手表的应用互联开发、集成应用市场H5、集成表盘市场H5。

__准备工作__

1. 进入[注册账户页面](https://www.openwearplay.com/ums/register)，根据页面提示，注册一个终端设备厂商账号。注册账号操作指导，见[“用户注册”章节](http://183.233.197.205:8099/platform/suer-registration
)。

2. 完成终端设备厂商账号注册后，进入[登录页面](https://www.openwearplay.com/ums/login)，完成账号登录。

3. 完成实名认证。实名认证操作指导，见[“实名认证”章节](http://183.233.197.205:8099/platform/name-authentication)。

`,
      },
      {
        id: 12,
        label: "联系我们",
        path: "/device/contact-us",
        data: `
# 联系我们

技术支持：openwearplay@zhikaihong.com

商务合作：business@zhikaihong.com

        `,
      },
    ],
  },
  {
    id: 2,
    label: "手机手表应用互联开发",
    children: [
      {
        id: 21,
        label: "概述",
        path: "/device/develop-overview",
        data: `
# 概述

## 业务介绍

Watch connect kit面向手机应用与服务开发者，提供与OH穿戴通讯的接口标准。

开发者通过调用Watch connect kit开放能力，可以实现手机上的生态应用与服务给OH穿戴设备发消息、发通知、传输数据，并获取穿戴设备状态等，也可以实现OH穿戴设备上的生态应用与服务给手机发消息、传输数据等。

## 开放能力

Watch connect kit聚焦openharmony穿戴设备能力开放，目前提供了以下能力：

- **设备基础能力**：
- **获取穿戴设备基础信息**：手机侧应用获取已配对的OH穿戴设备列表，包括：设备名称、设备类型等，以及查询该设备的连接状态、应用安装状态等。
- **应用间消息通信**：手机侧应用和穿戴设备侧应用双向传输消息和文件（如：文档、图片、音乐等）。
- **穿戴设备模板化通知**：手机侧应用发送模板化的通知到穿戴设备，开发者可以设置消息标题、内容、按钮。

## 技术架构

<img src="${docImg1}" alt="" style="max-width: 100%;">

说明：

1. 穿戴侧提供Watch Connect Kit能力，穿戴侧应用需要集成此接口，才能完成与手机侧通讯。

2. 手机/平板侧提供Watch Connect Kit, 上面的应用需要集成对应的Kit，通过互联APP，完成与穿戴交互。

## API 定义

### 1. [手机侧](phone)

### 2. [手表侧](watch)

## SDK 集成

[Watch Connect kit集成](https://gitee.com/cooperation-team-L0UI/watch-connect-kit/blob/master/README.md)

        `,
      },
      {
        id: 22,
        label: "手机APP watch-connect-kit Android接口",
        children: [
          {
            id: 221,
            label: "开发流程",
            path: "/device/app-overview",
            data: `
# 开发流程

demo主要是介绍手机上三方应用如何集成和使用社区提供的 \`watch-connect-kit\` ，连接 \`watch-connect-app\` 与 \`watch\` 上的应用通讯。

## demo开发环境

Android Studio: 2024.1.1 Patch 1。

Android SDK: 35。

Android Gradle Plugin Version: 8.5.0。

Gradle Version: 8.7。

Java Version: 1.8

## 集成kit准备

### kit下载

\`watch-connect-kit\` 获取链接：[点我下载](https://gitee.com/cooperation-team-L0UI/watch-connect-kit/tree/master/kit/android)。

### 工程集成kit

1. 在工程 \`app\` 目录下新建 \`libs\` 文件夹，将下载的 \`watch-connect-kit.aar\` 拷贝到 \`libs\` 中。

2. 在 \`build.gradle\` 中添加依赖。

\`\`\`gradle
dependencies {
    ......
    implementation files('libs/watch-connect-kit.aar')
    ......
}
\`\`\`

### kit接口定义

社区 \`watch-connect-kit\` 提供了接口定义及使用到的结构体等信息，可先查看熟悉。

kit接口定义链接：[点我查看](https://gitee.com/cooperation-team-L0UI/doc/tree/master/%E6%89%8B%E6%9C%BA%E6%89%8B%E8%A1%A8%E4%BA%92%E8%81%94%E5%BC%80%E5%8F%91/phone)。

### Demo

demo链接：[点我查看](https://gitee.com/cooperation-team-L0UI/watch-connect-kit/tree/master/demo/watch)。

## 集成kit开发

### 权限配置

\`watch-connect-kit-demo\` 会使用到文件传输功能，需要添加存储权限相关功能。需要注意的是，在不同版本中，存储权限配置和申请方式不同，需要单独处理。

### kit初始化

1. 自定义类继承 \`Application\` ，在 \`onCreate\` 中初始化 \`watch-connect-kit\` ，在手机上可能会有多个 \`watch-connect-app\` 提供服务，可以将这些服务都查询保存起来待后续调用时选择。所有服务的 **ACTION** 都指定为 **OH_WATCH_CONNECT_ACTION** 。

参考代码：

\`\`\`java
public class App extends Application {
    private static final String TAG = "test-kitDemo";
    private static final Map<String, WatchConnectEngine> kits = new HashMap<>();
    @Override
    public void onCreate() {
        super.onCreate();

        initWatchConnectKit();
    }

    private void initWatchConnectKit() {
        PackageManager packageManager = getPackageManager();
        Intent intent = new Intent();
        intent.setAction("OH_WATCH_CONNECT_ACTION");
        List<ResolveInfo> services = packageManager.queryIntentServices(intent, 0);
        for (ResolveInfo server : services) {
            Log.i(TAG, "MainActivity test serviceInfo.package name:" + server.serviceInfo.packageName);
            WatchConnectEngine engine = new WatchConnectEngine();
            boolean ret = engine.init("appId-1001-2001", "authId-6001-8001", getApplicationContext(), server.serviceInfo.packageName);
            if (ret) {
                Log.i("test-kitDemo", "App -> WatchConnectEngine init packageName(" + server.serviceInfo.packageName + ") success.");
            } else {
                Log.e("test-kitDemo", "App -> WatchConnectEngine init packageName(" + server.serviceInfo.packageName + ") fail.");
            }

            kits.put(server.serviceInfo.packageName, engine);
        }
    }

    public static WatchConnectEngine getWatchConnectEngine(String packageName) {
        return kits.getOrDefault(packageName, null);
    }
}
\`\`\`

2. 将 \`AndroidManifest.xml\` 文件中 \`application\` 配置的默认 \`name\` 修改为自定义Application名称 \`App\`。

\`\`\`xml
<application
    android:name=".App"
    ......
>
    ......
</application>
\`\`\`

### 调用kit接口方法

1. 导入包，其中入口是 \`WatchConnectEngine\` ,其它的都由 \`WatchConnectEngine\` 引出。这一步可由AndroidStudio工具自动完成。

\`\`\`java
import com.openharmony.watch.aidl.CancelFileTransferCallBack;
import com.openharmony.watch.aidl.Device;
import com.openharmony.watch.aidl.DeviceCallback;
import com.openharmony.watch.aidl.Message;
import com.openharmony.watch.aidl.Notification;
import com.openharmony.watch.aidl.NotifyCallback;
import com.openharmony.watch.aidl.Peer;
import com.openharmony.watch.aidl.PingCallback;
import com.openharmony.watch.aidl.Receiver;
import com.openharmony.watch.aidl.SendCallback;
import com.openharmony.watch.engine.WatchConnectEngine;
\`\`\`

2. 在自定义的 \`App\` 类中，已经获取所有服务都保存在 \`Map<String, WatchConnectEngine>\` ，在大多数情况下手机只安装了一个服务端，可以直接获取到对应的 \`WatchConnectEngine\` 实例;少数情况会安装多个服务端，此时可以弹框让用户选择其中一个服务。

3. 选择服务的 \`Activity\` 示例布局：

\`\`\`xml
<?xml version="1.0" encoding="utf-8"?>
<LinearLayout xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:id="@+id/main"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    android:layout_centerHorizontal="true"
    android:layout_margin="8dp"
    android:orientation="vertical"
    tools:context="com.openharmony.watch.SelectServiceActivity">

</LinearLayout>
\`\`\`

4. 选择服务的 \`Activity\` ，获取包名。

示例代码：

\`\`\`java
protected void onCreate(Bundle savedInstanceState) {
    super.onCreate(savedInstanceState);
    EdgeToEdge.enable(this);
    setContentView(R.layout.activity_select_service);
    ViewCompat.setOnApplyWindowInsetsListener(findViewById(R.id.main), (v, insets) -> {
        Insets systemBars = insets.getInsets(WindowInsetsCompat.Type.systemBars());
        v.setPadding(systemBars.left, systemBars.top, systemBars.right, systemBars.bottom);
        return insets;
    });

    layout = findViewById(R.id.main);
    PackageManager packageManager = getPackageManager();
    Intent intent = new Intent();
    intent.setAction("watchConnectApp.service.GET_KIT_SERVICE_ACTION");
    List<ResolveInfo> services = packageManager.queryIntentServices(intent, 0);
    for (ResolveInfo server : services) {
        Button btn = new Button(this);
        btn.setText(server.serviceInfo.packageName);
        btn.setOnClickListener(v -> {
            Intent it = new Intent();
            it.putExtra("packageName", server.serviceInfo.packageName);
            setResult(RESULT_OK, it);
            finish();
        });

        layout.addView(btn);
    }
}
\`\`\`

5. 通过 \`Activity\` 返回的结果拿到包名，选择对应的 \`WatchConnectEngine\` 实例。

示例代码：

\`\`\`java
ActivityResultLauncher<Intent> serviceLauncher = registerForActivityResult(new ActivityResultContracts.StartActivityForResult(), result -> {
    Log.i(TAG, "serviceLauncher -> onActivityResult");
    if (result != null && result.getData() != null) {
        String packageName = result.getData().getStringExtra("packageName");
        // 通过包名从 app 的 kits 中获取指定 engine
        engine = App.getWatchConnectEngine(packageName);
        // 处理后续业务
        ......
    } else {
        Toast.makeText(this, "Must select a service!!", Toast.LENGTH_SHORT).show();
    }
});
......

Intent intent = new Intent("com.openharmony.watch.SELECT_SERVICE_ACTIVITY");
serviceLauncher.launch(intent);
\`\`\`

6. 以获取配对设备接口为例，通过 \`WatchConnectEngine\` 的实例调用 \`getBondedDevices\` 之后，会通过传入 \`DeviceCallback\` 的 \`onGetResult\` 回调回结果，拿到 \`devices\` 后即可做后续业务。

\`\`\`java
engine.getBondedDevices(new DeviceCallback.Stub() {
    @Override
    public void onGetResult(List<Device> devices) throws RemoteException {
        Log.i(TAG, "getBondedDevices result, devices:" + devices);

        ......
    }
});
\`\`\`

7. 其它接口可以参考 \`getBondedDevices\` 的调用方式。

## 注意事项

### 权限问题

开发会需要存储，网络等权限，在 \`AndroidManifest.xml\` 中申明，在需要权限的操作前，最好动态检查和申请，建议使用 \`EasyPermissions\`，\`RxPermissions\` 等权限管理工具。

### 线程问题

执行长时任务时，不要在UI线程执行，建议使用RxAndroid等库来调度线程的切换。

### 获取kit服务问题

1.如果手机上只安装了一个集成kit服务端时，其中 \`3.3.3 - 3.3.5\` 等几步可不用执行。

2.调用 \`WatchConnectEngine\` 的 \`init\` 时，内部会通过 \`bindService\` 来获取与服务端的连接，由于android机制原因， \`ServiceConnection\` 的 \`onServiceConnected\` 在调用 \`bindService\` 后不是同步连接的，如果在 \`init\` 执行后立即执行 \`WatchConnectEngine\` 其它函数，会出现还未连接到服务的情况。建议 \`init\` 尽量提前执行。

            `,
          },
          {
            id: 222,
            label: "接口说明",
            path: "/device/app-interface",
            data: `
# 接口说明文档

## 常量定义

### ErrCode

| 类型                    | 常量                                     | 值     | 描述               |
| :------                 | :-----                                  | :----- | :-----             |
| public static final int | ERROR_CODE_PING_WATCH_APP_NOT_EXIST     | 200    | 手表应用未安装       |
| public static final int | ERROR_CODE_PING_WATCH_APP_NOT_RUNNING   | 201    | 手表应用已安装未启动 |
| public static final int | ERROR_CODE_PING_WATCH_APP_EXIST_RUNNING | 202    | 手表应用已安装已启动 |
| public static final int | ERROR_CODE_PING_OTHER                   | 203    | 其他错误            |
| public static final int | ERROR_CODE_PING_PHONE_APP_NOT_EXIST     | 204    | 手机应用未安装       |
| public static final int | ERROR_CODE_PING_PHONE_APP_NOT_RUNNING   | 205    | 手机应用已安装       |
| public static final int | ERROR_CODE_COMM_FAIL                    | 206    | 失败                |
| public static final int | ERROR_CODE_COMM_SUCCESS                 | 207    | 成功                |

### CAPABILITY

| 类型                    | 常量                           | 值      | 描述    |
| :------                 | :-----                        | :-----  | :-----  |
| public static final int | DEVICE_CAPABILITY_SUPPORT     | 0       | 支持    |
| public static final int | DEVICE_CAPABILITY_NOT_SUPPORT | 1       | 不支持  |
| public static final int | DEVICE_CAPABILITY_UNKNOWN     | 2       | 未知    |

### NotificationTemplate

| 类型                    | 常量                                 | 值      | 描述    |
| :------                 | :-----                              | :-----  | :-----  |
| public static final int | NOTIFICATION_TEMPLATE_NO_BUTTON     | 0       | 没有按钮 |
| public static final int | NOTIFICATION_TEMPLATE_ONE_BUTTON    | 1       | 一个按钮 |
| public static final int | NOTIFICATION_TEMPLATE_TWO_BUTTONS   | 2       | 两个按钮 |
| public static final int | NOTIFICATION_TEMPLATE_THREE_BUTTONS | 3       | 三个按钮 |

## WatchConnectEngine功能接口类

OH Wear Engine功能总入口，主要用于认证初始化kit，获取配对设备，与设备通讯，传输文件等。

提供的接口如下：

| 接口                | 描述                 |
| :------------------ | :------------------ |
| init                | 应用厂家认证，需要传入应用appid和authId信息。 |
| connectKitService   | 连接watch-connect-kit服务端。 |
| getBondedDevices    | 获取已经和App配对的具有应用间消息通信能力的设备列表。|
| getAvailableKbytes  | 获取穿戴设备剩余存储空间大小。|
| ping                | 检测需要通信的穿戴设备侧应用是否在线。|
| send                | 向需要通信的穿戴设备侧应用发送通信消息。|
| cancelFileTransfer  | 向需要通信的穿戴设备取消文件发送。 |
| isAppInstalled      | 查看是否安装指定的设备应用。|
| getAppVersion       | 查看已安装的指定设备应用版本号。|
| registerReceiver    | 向指定的设备上的指定应用注册一个接收消息或文件的回调对象。|
| unregisterReceiver  | 注销一个已经被注册的监测对象。|
| notify              | 发送一条通知到指定设备。|

### init

#### 接口功能

应用厂家认证，初始化 \`watch-connect-kit\` 。

#### 接口原型

boolean init(String appId, String authId)

**参数**

| 参数    | 类型    | 描述       |
| :------ | :----- | :----------|
| appId   | String | 应用appId  |
| authId  | String | authId信息 |

**返回值**

返回值类型：\`boolean\`，应用厂家认证，是否初始化kit成功。

**示例**

\`\`\`java
WatchConnectEngine engine = new WatchConnectEngine();
boolean ret = engine.init("appId-1001-2001", "authId-6001-8001", getApplicationContext());
if (ret) {
    Log.i(TAG, "App -> WatchConnectEngine init success.");
} else {
    Log.e(TAG, "App -> WatchConnectEngine init fail.");
}
\`\`\`

### connectKitService

#### 接口功能

连接 \`watch-connect-kit\` 服务端。

#### 接口原型

void connectKitService(Context context, String kitServerPackageName, ServiceConnectionListener listener)

**参数**

| 参数                  | 类型                       | 描述               |
| :------               | :-----                    | :----------        |
| context               | Context                   | 应用上下文          |
| kitServerPackageName  | String                    | 服务端包名          |
| listener              | [ServiceConnectionListener](#serviceconnectionlistener) | 服务连接状态监测接口 |

**示例**

\`\`\`java
Context context = ...;
String packageName = "....";
engine.connectKitService(context, packageName, new WatchConnectEngine.ServiceConnectionListener() {
    @Override
    public void onServiceConnectResult(boolean isConnect) {
        Log.i(TAG, "App -> WatchConnectEngine onServiceConnectResult:" + isConnect + ".");
        if (isConnect) {
            Log.i(TAG, "Connect Service Success!!");
        } else {
            Log.e(TAG, "Connect Service fail!!");
        }
    }

    @Override
    public void onServiceDisconnected() {
        Log.i(TAG, "App -> WatchConnectEngine onServiceDisconnected!!");
    }
});
\`\`\`

### getBondedDevices

#### 接口功能

获取已经和App配对的具有应用间消息通信能力的设备列表。以回调的方式返回设备列表。

#### 接口原型

void getBondedDevices(DeviceCallback callback)

**参数**

| 参数       | 类型                               | 描述                      |
| :------    | :-----                            | :----------               |
| callback   | [DeviceCallback](#devicecallback) | 回调函数，返回配对设备列表  |

**示例**

\`\`\`java
engine.getBondedDevices(new DeviceCallback.Stub() {
    @Override
    public void onGetResult(List<Device> devices) {
        Log.i(TAG, "getBondedDevices result, devices:" + devices);
        ......
    }
});
\`\`\`

### getAvailableKbytes

#### 接口功能

获取穿戴设备剩余存储空间大小

#### 接口原型

long getAvailableKbytes(Device device)

**参数**

| 参数       | 类型                               | 描述                      |
| :------    | :-----                            | :----------               |
| device     | [Device](#device)                 | 指定设备  |

**返回值**

返回值类型：\`long\`，返回设备的剩余存储空间大小，单位：KB。

**示例**

\`\`\`java
Device selectedDevice = ....;
long freeSize = engine.getAvailableKbytes(selectedDevice);
Log.i(TAG, "Device's available size:" + freeSize);
\`\`\`

### ping

#### 接口功能

检测需要通信的穿戴设备侧应用是否在线。

#### 接口原型

void ping(Peer peer, PingCallback pingCallback)

**参数**

| 参数          | 类型          | 描述                 |
| :------       | :-----       | :----------          |
| peer          | [Peer](#peer)                 | 指定通讯的设备        |
| pingCallback  | [PingCallback](#pingcallback) | 回调函数，返回检测结果 |

**示例**

\`\`\`java
Peer peer = ....;
engine.ping(peer, new PingCallback.Stub() {
    @Override
    public void onPingResult(int errCode) {
        Log.i(TAG, "Ping Result code:" + errCode);
    }
});
\`\`\`

### send

#### 接口功能

向需要通信的穿戴设备侧应用发送通信消息。可发送文本或是文件消息。

#### 接口原型

void send(Peer peer, Message message, SendCallback sendCallback)

**参数**

| 参数          | 类型          | 描述                       |
| :------       | :-----       | :----------                |
| peer          | [Peer](#peer)                 | 指定通讯的设备              |
| message       | [Message](#message)           | 要发送的消息，根据type来标识是文本还是文件消息                |
| sendCallback  | [SendCallback](#sendcallback) | 回调函数，反馈传输进度和结果 |

**示例**

\`\`\`java
// 文本消息
Device selectedDevice = ....;
String sendMessageStr = "send message to server";
String pkgName = "watch app package name";
Peer peer = new Peer(selectedDevice, "fingerPrint", getPackageName(), pkgName);
Integer type = 0;
Message msg = new Message(type, sendMessageStr.getBytes(), "send message to server", null, "", "");
engine.send(peer, msg, new SendCallback.Stub() {
    @Override
    public void onSendProgress(long count) {
        Log.i(TAG, "onSendProgress, progress:" + count);
    }

    @Override
    public void onSendResult(int errCode) {
        Log.i(TAG, "onSendResult, code:" + errCode);
    }
});

// 文件消息
Device selectedDevice = ....;
String sendMessageStr = "";
String pkgName = "watch app package name";
Peer peer = new Peer(selectedDevice, "fingerPrint", getPackageName(), pkgName);
Integer type = 1;
ParcelFileDescriptor pfd = ParcelFileDescriptor.open(new File("文件路径"), ParcelFileDescriptor.MODE_READ_WRITE);
String fileName = "文件名"; // 消息中的文件名，不带路径，如：xxx.mp3，yyy.txt。
String dstFilePath = "表端保存目录"; // 文件传到表端后保存的目录，不带文件名及沙箱前缀，参数格式：/a/b/c/，由服务端组装沙箱前缀。
Message msg = new Message(type, sendMessageStr.getBytes(), "file description", pfd, fileName, dstFilePath);
engine.send(peer, msg, new SendCallback.Stub() {
    @Override
    public void onSendProgress(long count) {
        Log.i(TAG, "onSendProgress, progress:" + count);
    }

    @Override
    public void onSendResult(int errCode) {
        Log.i(TAG, "onSendResult, code:" + errCode);
    }
});
\`\`\`

### cancelFileTransfer

#### 接口功能

通过设备应用对象来向需要通信的穿戴取消文件发送。

#### 接口原型

void cancelFileTransfer(Peer peer, Message message, CancelFileTransferCallBack cancelFileTransferCallBack)

**参数**

| 参数                        | 类型                        | 描述                       |
| :------                     | :-----                     | :----------                |
| peer                        | [Peer](#peer)              | 指定通讯的设备              |
| message                     | [Message](#message)        | 要发送的消息，根据type来标识是文本还是文件消息 |
| cancelFileTransferCallBack  | CancelFileTransferCallBack | 回调函数，反馈传输取消结果 |

**示例**

\`\`\`java
Peer peer = {调用send时传入的peer};
Message msg = {调用send时传入的msg}; // type = 1，为文件时的msg
engine.cancelFileTransfer(peer, msg, new CancelFileTransferCallBack.Stub() {
    @Override
    public void onCancelFileTransferResult(int errCode) {
        Log.i(TAG, "Cancel file transfer, resutl:" + errCode);
    }
});
\`\`\`

### isAppInstalled

#### 接口功能

查看指定的设备是否安装给定的应用。

#### 接口原型

boolean isAppInstalled(Peer peer)

**参数**

| 参数           | 类型    | 描述          |
| :------        | :----- | :----------   |
| peer           | [Peer](#peer) | 指定的设备     |

**返回值**

返回值类型：\`boolean\`，返回是否安装。

**示例**

\`\`\`java
Device selectedDevice = ....;
String pkgName = "watch app package name";
Peer peer = new Peer(selectedDevice, "fingerPrint", getPackageName(), pkgName);
boolean ret = engine.isAppInstalled(peer);
if (ret) {
    Log.i(TAG, "App(" + pkgName + ") is installed.");
} else {
    Log.e(TAG, "App(" + pkgName + ") is not installed.");
}
\`\`\`

### getAppVersion

#### 接口功能

查看已安装的指定设备应用版本号。

#### 接口原型

int getAppVersion(Device device, String targetPkgName)

**参数**

| 参数           | 类型    | 描述          |
| :------        | :----- | :----------   |
| peer           | [Peer](#peer) | 指定的设备     |

**返回值**

返回值类型：\`int\`，返回给定的应用的版本号，未找到包名，出错等返回 \`-1\` 。

**示例**

\`\`\`java
Device selectedDevice = ....;
String pkgName = "watch app package name";
Peer peer = new Peer(selectedDevice, "fingerPrint", getPackageName(), pkgName);
int ret = engine.getAppVersion(peer);
if (ret != -1) {
    Log.i(TAG, "app version:" + ret);
} else {
    Log.e(TAG, "getAppVersion error!!");
}
\`\`\`

### registerReceiver

#### 接口功能

通过设备应用对象来向指定的设备上的指定应用注册一个接收消息或文件的回调对象。

#### 接口原型

void registerReceiver(Peer peer, Receiver receiver)

**参数**

| 参数           | 类型      | 描述          |
| :------        | :-----   | :----------   |
| peer           | [Peer](#peer)         | 指定的设备     |
| receiver       | [Receiver](#receiver) | 回调函数，接收设备应用发过来的消息(文本或文件) |

**示例**

\`\`\`java
String targetPkgName = "watch app package name";
Peer peer = new Peer(selectedDevice, "fingerPrint", targetPkgName);
Receiver receiver = new Receiver.Stub() {
    @Override
    public void onReceiveMessage(Message message) throws RemoteException {
        Log.i(TAG, "registerReceiver onReceiveMessage:" + message);
        if (message.getType() == 0) { // string message
            Log.i(TAG, "string message");
        } else if (message.getType() == 1) { // file message
            Log.i(TAG, "file message");
        } else {
            Log.e(TAG, "message type error!!");
        }
    }
};
engine.registerReceiver(peer, receiver);
\`\`\`

### unregisterReceiver

#### 接口功能

注销一个已经被注册的监测对象。

#### 接口原型

void unregisterReceiver(Receiver receiver)

**参数**

| 参数           | 类型      | 描述          |
| :------        | :-----   | :----------   |
| receiver       | [Receiver](#receiver) | 回调函数，已经注册的Receiver对象 |

**示例**

\`\`\`java
Peer peer = ......;
Receiver receiver = ......;
engine.registerReceiver(peer, receiver);
......

engine.unregisterReceiver(receiver);
\`\`\`

### notify

#### 接口功能

发送一条通知到指定设备。

#### 接口原型

void notify(Device device, Notification notification, NotifyCallback callback)

**参数**

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| device         | [Device](#device)                 | 指定的设备     |
| notification   | [Notification](#notification)     | 通知信息，包括标题，内容等 |
| callback       | [NotifyCallback](#notifycallback) | 回调函数，反馈通知结果 |

**示例**

\`\`\`java
Map<Integer, String> btns = new HashMap<>();
btns.put(1, "确定");
btns.put(2, "取消");
btns.put(3, "忽略");
Device selectedDevice = ......;
String pkgName = "watch app package name";
Notification notification = new Notification(btns, pkgName, 1, "message body" , "message title");
engine.notify(selectedDevice, notification, new NotifyCallback.Stub() {
    @Override
    public void onError(Notification notification, int errorCode, String errorMsg) {
        Log.e(TAG, "notify callback onError, notification:" + notification + ", errorCode:" + errorCode + ", errorMsg:" + errorMsg);
    }

    @Override
    public void onResult(Notification notification, int feedback) {
        Log.i(TAG, "notify callback onResult, notification:" + notification + ", feedback:" + feedback);
    }
});
\`\`\`

## 接口回调函数

### ServiceConnectionListener

#### 说明

服务连接状态监测接口。

#### 定义

\`\`\`java
interface ServiceConnectionListener {
    void onServiceConnectResult(boolean isConnect);
    void onServiceDisconnected();
}
\`\`\`

#### onServiceConnectResult

\`connectKitService\` 时的结果回调。

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| isConnect      | boolean        | 连接结果，true:成功，false:失败 |

#### onServiceDisconnected

与服务端断开连接时的回调。

| 参数      | 类型      | 描述          |
| :------   | :-----   | :----------   |
| 无        | 无        | 无            |

### DeviceCallback

#### 说明

获取配对设置列表时的回调。

#### 定义

\`\`\`java
interface DeviceCallback {
    void onGetResult(List<Device> devices);
}
\`\`\`

#### onGetResult

\`getBondedDevices\` 时的结果回调。

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| devices        | List<[Device](#device)>   | 设备列表       |

### PingCallback

#### 说明

Ping检查设备时的回调。

#### 定义

\`\`\`java
interface PingCallback {
    void onPingResult(int errCode);
}
\`\`\`

#### onPingResult

\`ping\` 的结果回调。

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| errCode        | int            | 错误码，参考常量[ErrCode](#errcode)中的定义       |


### SendCallback

#### 说明

发送消息的回调接口。

#### 定义

\`\`\`java
interface SendCallback {
    void onSendProgress(long count);
    void onSendResult(int errCode);
}
\`\`\`

#### onSendProgress

\`send\` 传输文件时的进度回调。

| 参数           | 类型            | 描述              |
| :------        | :-----         | :----------       |
| count          | long            | 进度值，0 ~ 100   |

#### onSendResult

\`send\` 的结果回调。

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| errCode        | int            | 错误码，参考常量[ErrCode](#errcode)中的定义       |


### CancelFileTransferCallBack

#### 说明

通过设备应用对象来向需要通信的穿戴取消文件发送。

#### 定义

\`\`\`java
interface CancelFileTransferCallBack {
    void onCancelFileTransferResult(int errCode);
}
\`\`\`

#### onCancelFileTransferResult

取消传输文件时的结果回调。

| 参数           | 类型            | 描述              |
| :------        | :-----         | :----------       |
| errCode        | int            | 错误码，参考常量[ErrCode](#errcode)中的定义   |

### Receiver

#### 说明

点对点通信的监测接口。

#### 定义

\`\`\`java
interface Receiver {
    void onReceiveMessage(Message message);
}
\`\`\`

#### onReceiveMessage

向设备注册接收消息的回调。

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| message        | [Message](#message)        | 接收到的消息，包括文本或文件消息       |

### NotifyCallback

#### 说明

通知反馈的回调，反馈用户在穿戴侧收到通知后的行为。

#### 定义

\`\`\`java
interface NotifyCallback {
    void onError(Notification notification, int errorCode, String errorMsg);
    void onResult(Notification notification, int feedback);
}
\`\`\`

#### onError

通知异常反馈。

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| notification   | [Notification](#notification)   | 通知内容信息               |
| errorCode      | int                             | 错误码，参考常量[ErrCode](#errcode)中的定义    |
| errorMsg       | String                          | 错误信息                  |

#### onResult

通知反馈。

| 参数           | 类型            | 描述          |
| :------        | :-----         | :----------   |
| notification   | [Notification](#notification)   | 通知内容信息               |
| feedback      | int            | 反馈。<br/>feedback：<br/>0：物理HOME键退出或者灭屏；<br/>1：删除消息；<br/>2：用户点击第一个按钮；<br/>3：用户点击第二个按钮；<br/>4：用户点击第三个按钮    |

## 属性类

### Device

#### 说明

定义了穿戴设备的属性和能力。

#### 属性

| 类型      | 属性                | 描述          |
| :------   | :-----             | :----------   |
| String    | model              | 设备型号       |
| String    | name               | 设备名称       |
| String    | uuid               | 设备uuid       |
| Integer   | productType        | 产品类型(0：穿戴类产品)       |
| String    | reservedness       | 保留字段的值       |
| String    | softwareVersion    | 穿戴设备版本号       |
| boolean   | isConnected        | 设备是否连接       |
| Integer   | p2pCapability      | 是否支持应用间消息通信能力([CAPABILITY](#capability))       |
| Integer   | notifyCapability   | 是否支持穿戴模板化通知能力([CAPABILITY](#capability))       |
| Integer   | sensorCapability   | 是否支持穿戴设备传感器获取能力([CAPABILITY](#capability))   |
| Integer   | deviceType         | 设备类型       |

#### 方法

| 返回类型    | 函数                   | 描述                   |
| :------    | :-----                 | :----------            |
| String     | getModel               | 获取设备型号          |
| String     | getName                | 获取设备名称          |
| String     | getUuid                | 获取设备uuid          |
| Integer    | getProductType         | 获取产品类型(0：穿戴类产品)          |
| String     | getReservedness        | 获取保留字段的值          |
| String     | getSoftwareVersion     | 获取穿戴设备版本号          |
| boolean    | isConnected            | 判断设备是否连接(true：已连接；false：未连接)|
| Integer    | getP2pCapability       | 获取是否支持应用间消息通信能力([CAPABILITY](#capability))          |
| Integer    | getNotifyCapability    | 获取是否支持穿戴模板化通知能力([CAPABILITY](#capability))          |
| Integer    | getSensorCapability    | 获取是否支持穿戴设备传感器获取能力([CAPABILITY](#capability))      |
| Integer    | getDeviceType          | 获取设备类型(-1:未知； 0：运动手表)          |

### Peer

#### 说明

需要通信的设备应用对象。

#### 属性

| 类型      | 属性         | 描述          |
| :------   | :-----      | :----------   |
| [Device](#device)    | device      | 设备对象      |
| String               | fingerPrint | 指纹信息      |
| String               | srcPkgName  | 手机侧应用包名 |
| String               | dstPkgName  | 设备侧应用包名 |

#### 方法

| 返回类型    | 函数               | 描述                 |
| :------    | :-----             | :----------          |
| [Device](#device)     | getDevice          | 获取设备对象          |
| String                | getFingerPrint     | 获取指纹信息          |
| String                | getSrcPkgName      | 获取手机侧应用包名     |
| String                | getDstPkgName      | 获取设备侧应用包名     |
| void                  | setFingerPrint     | 设置指纹信息          |
| void                  | setSrcPkgName      | 设置手机侧应用包名     |
| void                  | setDstPkgName      | 设置设备侧应用包名     |

### Message

#### 说明

与设备侧通信的Message对象。

#### 属性

| 类型                 | 属性         | 描述                                  |
| :------              | :-----      | :----------                           |
| Integer              | type        | 消息类型(0：文本；1：文件)              |
| byte[]               | data        | 文本信息                               |
| String               | description | 描述                                   |
| ParcelFileDescriptor | pfd         | 文件描述符                             |
| String               | fileName    | 文件名，不带路径，如：xxx.mp3，yyy.txt。 |
| String               | dstFilePath | 对端保存目录，不带文件名及沙箱前缀，如：/a/b/c/    |

#### 方法

| 返回类型              | 函数              | 描述                 |
| :------              | :-----            | :----------          |
| Integer              | getType           | 获取消息类型          |
| byte[]               | getData           | 获取文本信息          |
| String               | getDescription    | 获取描述              |
| ParcelFileDescriptor | getFileDescriptor | 获取文件描述符        |
| String               | getFileName       | 获取文件名            |
| String               | getDstFilePath    | 获取对端文件保存目录   |

### Notification

#### 说明

通知类。

#### 属性

| 类型                 | 属性            | 描述             |
| :------              | :-----         | :----------      |
| Map<Integer, String> | buttonContents | 通知按钮内容列表  |
| String               | packageName    | 通知的应用包名    |
| Integer              | templatedId    | 通知模板的ID     |
| String               | text           | 通知内容         |
| String               | title          | 通知标题         |

#### 方法

| 返回类型              | 函数               | 描述                 |
| :------              | :-----             | :----------          |
| Map<Integer, String> | getButtonContents  | 获取通知按钮内容列表   |
| String               | getPackageName     | 获取通知的应用包名     |
| Integer              | getTemplatedId     | 获取通知模板的ID      |
| String               | getText            | 获取通知内容          |
| String               | getTitle           | 获取通知标题          |

            `,
          },
          {
            id: 223,
            label: "Demo",
            path: "/device/app-demo",
            data: `
## Demo获取 

获取链接：[点我下载](https://gitee.com/cooperation-team-L0UI/watch-connect-kit/tree/master/demo/phone/android)。
            `,
          },
        ],
      },
      {
        id: 23,
        label: "手表watch-connect-kit 接口",
        children: [
          {
            id: 231,
            label: "接口说明",
            path: "/device/watch-interface",
            data: `
# 接口说明

本接口提供给手表上的应用与手机上的应用通讯的接口

## API

| API                | 说明                       |
| ------------------ | -------------------------- |
| getLocalVersion    | 获取本地WatchConnect版本号 |
| getPeerVersion     | 获取对端WatchConnect版本号 |
| setPeerInfo        | 设置对端应用的指纹         |
| ping               | 检查对端应用程序           |
| send               | 发送数据                   |
| registerReceiver   | 注册对端消息接收           |
| unregisterReceiver | 注销对端消息接收           |

## 导入模块

\`\`\`
    import watchConnect from '@ohos.watchConnect';
\`\`\`

## 错误码

| 类型                         | 错误码 | 说明                        |
| ---------------------------- | ------ | --------------------------- |
| PING_WATCH_APP_NOT_EXIST     | 200    | 手表应用未安装              |
| PING_WATCH_APP_NOT_RUNNING   | 201    | 手表应用已安装未启动        |
| PING_WATCH_APP_EXIST_RUNNING | 202    | 手表应用已安装已启动        |
| PING_OTHER                   | 203    | 其他错误                    |
| PING_PHONE_APP_NOT_EXIST     | 204    | 手机应用未安装              |
| PING_PHONE_APP_NOT_RUNNING   | 205    | 手机应用已安装              |
| SEND_FAIL                    | 206    | 发送消息失败                |
| SEND_SUCCESS                 | 207    | 发送消息成功                |
| CHECK_WATCH_APP_INSTALLED    | 208    | 应用已安装                  |
| RESERVED_CODE                | 209    | 预留（离线消息）            |
| INVALID_ARGUMENT             | 210    | 参数错误                    |
| LOCAL_VERSION_TOO_LOW        | 211    | 手表WatchConnectKit版本太低 |
| PEER_VERSION_TOO_LOW         | 212    | 对端WatchConnectKit版本太低 |

## 权限列表

无

## watchConnect.getLocalVersion

getLocalVersion(): string

获取本地watchConnect版本号

**返回值**

| 类型   | 非空 | 说明                     |
| ------ | ---- | ------------------------ |
| string | 是   | 本地WatchConnect版本号。 |

**示例**

\`\`\`
  export default {    
        getLocalVewsion() {        
          let version = watchConnect.getLocalVersion();    
        },
      }
\`\`\`

## watchConnect.getPeerVersion

getPeerVersion(Object): void

获取对端watchConnect版本号

**参数**

| 参数名          | 类型       | 必填  | 说明           |
| ------------ | -------- | --- | ------------ |
| onGetVersion | Function | 是   | 获取版本信息的回调函数。 |

onGetVersion返回值：

| 参数名     | 类型     | 说明   |
| ------- | ------ | ---- |
| version | string | 版本号。 |

**示例**

\`\`\`
  export default {    
      getPeerVersion() {        
         watchConnect.getPeerVersion({
            onGetVersion: function(version) {                
               console.info('getPeerVersion version:' + version);            
            },             
         });    
      },
  }
\`\`\`

## watchConnect.setPeerInfo

setPeerInfo(Object): void

设置对端应用的指纹

**参数**

| 参数名         | 类型       | 必填  | 说明               |
| ----------- | -------- | --- | ---------------- |
| bundleName  | string   | 是   | 对端应用的bundleName。 |
| fingerPrint | string   | 是   | 对端应用的指纹证书。       |
| success     | Function | 否   | 接口调用成功的回调函数。     |
| fail        | Function | 否   | 接口调用失败的回调函数。     |

**示例**

\`\`\`
  export default {    
      setPeerInfo() {        
         watchConnect.setPeerInfo({
            bundleName: "xxxx.xxxx.xxxx", // 对端应用bundleName
            fingerPrint: "xxx", // 对端应用的指纹证书
            success: function() {                
               console.info('setPeerInfo success');            
            },
            fail: function(data, code) {
               console.error('setPeerInfo failed. Code: ' + code + '; Data: ' + data);
            },             
         });    
      },
  }
\`\`\`

## watchConnect.ping

ping(Object): void

检查对端应用程序

**参数**

| 参数名          | 类型       | 必填  | 说明            |
| ------------ | -------- | --- | ------------- |
| message      | string   | 是   | 消息。           |
| success      | Function | 否   | 接口调用成功时的回调函数。 |
| fail         | Function | 否   | 接口调用失败时的回调函数。 |
| onPingResult | Function | 否   | 接口调用结束的回调函数。  |

**示例**

\`\`\`
  export default {    
      ping() {        
         watchConnect.ping({
            message: "message", // 通讯消息
            success: function() {                
               console.info('ping success');            
            },
            fail: function(data, code) {
              console.error('ping failed. Code: ' + code + '; Data: ' + data);
            },  
            onPingResult: function(data, code) {
              console.error('ping complete. Code: ' + code + '; Data: ' + data);
            },           
         });    
      },
  }
\`\`\`

## watchConnect.send

send(Object): void

发送数据

**参数**

| 参数名         | 类型                         | 必填 | 说明                       |
| -------------- | ---------------------------- | ---- | -------------------------- |
| message        | [IWatchConnectData](#target) | 是   | 消息。                     |
| success        | Function                     | 否   | 接口调用成功时的回调函数。 |
| fail           | Function                     | 否   | 接口调用失败时的回调函数。 |
| onSendResult   | Function                     | 否   | 接口调用结束的回调函数。   |
| onSendProgress | Function                     | 否   | 进度更新的回调函数         |

**IWatchConnectData**<a id="target"></a> 类型：

| 参数名        | 类型                  | 必填  | 说明                                                                  |
| ---------- | ------------------- | --- | ------------------------------------------------------------------- |
| type       | 'message' \\| 'file' | 是   | 数据类型                                                                |
| name       | string              | 是   | 数据或文件的名称                                                            |
| content    | string              | 是   | type message: 数据的字符串<br/>type file: 文件路径名                           |
| filemode   | string              | 是   | 文件模式<br/>text：txt,json,xml<br/>binary: img bin, dial res<br/>others |
| permission | 'R' \\| 'W' \\| 'RW'  | 是   | 文件权限                                                                |

onSendProgress 返回值

| 参数名   | 类型     | 说明          |
| ----- | ------ | ----------- |
| count | number | 进度 0 ~ 100。 |

**示例**

\`\`\`
  export default {    
      send() {    
          let dataInfo = {
              type: 'file',
              name: 'config.json',
              content: 'internal://app/config.json',
              filemode: 'text',
              permission: 'R'
          };   
          watchConnect.send({
              message: dataInfo, 
              success: function() {                
                  console.info('send success');            
              },
              fail: function(data, code) {
                 console.error('send failed. Code: ' + code + '; Data: ' + data);
              }, 
              onSendResult: function(data, code) {
                 console.error('send complete. Code: ' + code + '; Data: ' + data);
              },
              onSendProgress: function(count) {
                 console.error('send recive progress: ' + count);
              },            
          });    
      },
  }
\`\`\`

## watchConnect.registerReceiver

registerReceiver(Object): void

注册对端消息接收

| 参数名              | 类型       | 必填  | 说明            |
| ---------------- | -------- | --- | ------------- |
| success          | Function | 否   | 接口调用成功时的回调函数。 |
| fail             | Function | 否   | 接口调用失败时的回调函数。 |
| onReceiveMessage | Function | 否   | 接口调用结束的回调函数。  |
| progress         | Function | 否   | 进度更新的回调函数     |

onReceiveMessage 返回值：

- message类型为file时：

| 参数名  | 类型                         | 说明 |
| ------- | ---------------------------- | ---- |
| message | [IWatchConnectData](#target) | 消息 |

- message类型为message时：

| 参数名  | 类型   | 说明 |
| ------- | ------ | ---- |
| message | string | 消息 |

progress 返回值：

| 参数名   | 类型     | 说明          |
| ----- | ------ | ----------- |
| count | number | 进度 0 ~ 100。 |

**示例**

\`\`\`
  export default {    
      registerReceiver() { 
          var dataInfo = {};      
          watchConnect.registerReceiver({
              success: function() {                
                  console.info('registerReceiver success');            
              },
              fail: function(data, code) {
                 console.error('registerReceiver failed. Code: ' + code + '; Data: ' + data);
              }, 
              onReceiveMessage: function(message) {
                  dataInfo.type = message.type; 
                  dataInfo.name = message.name;
                  dataInfo.content = message.content; 
                  dataInfo.filemode = message.filemode;
                  dataInfo.permission = message.permission; 
                  console.error('registerReceiver complete. message: ' + JSON.stringify(message));
              },
              progress: function(count) {
                  console.error('registerReceiver recive progress: ' + count);
              },            
          });    
      },
  }
\`\`\`

## watchConnect.unregisterReceiver

unregisterReceiver(Object): void

注销对端消息接收

| 参数名     | 类型       | 必填  | 说明            |
| ------- | -------- | --- | ------------- |
| success | Function | 否   | 接口调用成功时的回调函数。 |
| fail    | Function | 否   | 接口调用失败时的回调函数。 |

**示例**

\`\`\`
  export default {    
      unregisterReceiver() {  
          watchConnect.unregisterReceiver({
              success: function() {                
                  console.info('unregisterReceiver success');            
              },
              fail: function(data, code) {
                 console.error('unregisterReceiver failed. Code: ' + code + '; Data: ' + data);
              },           
          });    
      },
  }
\`\`\`

            `,
          },
          {
            id: 232,
            label: "Demo",
            path: "/device/watch-demo",
            data: `
## Demo获取 

获取链接：[点我下载](https://gitee.com/cooperation-team-L0UI/watch-connect-kit/tree/master/demo/watch)。
            `,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    label: "集成应用市场H5",
    path: "/device/market-overview",
    data: `
# 集成应用市场H5

## 概述

目前在 \`watch-connect-app\` 应用中，是通过 \`webview\` 加载H5页面来展示应用市场，然后通过 \`JSbridge\` 来实现H5页面 \`javascript\` 和Android \`java\` 的互相调用，其中接口定义，传参格式等由H5开发和android开发协商。

## H5地址获取

1. 注册整机品牌公司账号，[点我注册](https://www.openwearplay.com/ums/register)

   ![](assets/register.png) 
   <img src="${register}" alt="" style="max-width: 100%;">

2. 登录账号，进入\`用户管理\`模块中的\`个人中心\`

   ![](assets/smrz.png)
   <img src="${smrz}" alt="" style="max-width: 100%;">

3. 申请实名认证

   ![](assets/auth.png) 
   <img src="${auth}" alt="" style="max-width: 100%;">

4. 获取H5地址

## 应用开发环境

- Android Studio: 2024.1.1 Patch 1。

- Android SDK: 35。

- Android Gradle Plugin Version: 8.5.0。

- Gradle Version: 8.7。

- Java Version: 1.8


## 集成准备

### 权限申请

当前应用市场在使用中会涉及到网络，存储，蓝牙等权限，需要在 \`AndroidManifest.xml\` 文件中预先配置，在需要相关权限的操作前，最好动态检查是否已获取到指定权限，如没有权限，先动态申请权限后操作业务。

### 应用市场网站工程引入dsbridge

引入dsbridge.js相关的实现，拷贝到工程中，目录结构如下：

![](assets/2.png)
<img src="${docImg12}" alt="" style="max-width: 100%;">

### Android工程引入JSbridge实现

引入JSbridge相关的实现，拷贝到工程中，目录结构如下：

![](assets/1.png)
<img src="${docImg11}" alt="" style="max-width: 100%;">
## H5中Javascript调用Java

### 接口定义

社区提供了android的接口，开发者可以先了解有哪些接口及具体功能。

接口定义链接：[点我查看](##8.HWOHBridge接口)。

### 调用流程

1. 引入 \`dsbridge.js\` 文件，注册 \`dsbridge\`。

2. 目前在android java中只提供了一个入口接口 **hwohBridgeCallNative** 供js调用，接口是通过 \`WebView\` 实例的 \`addJavascriptObject(new JsApi(this), null)\` 来注入到页面中的，不同的操作由参数中的 \`opt\` 字段来区分和分发，参数都以json的格式来传递。

3. 先定义参数，主要是 \`handlerName\`，\`data.opt\`，\`data.param\` 3个，具体含义：

- handlerName：调用android java的入口函数名，目前是唯一入口。
- data.opt：调用android java中的具体操作，\`hwohBridgeCallNative\` 中会根据 \`opt\` 分发到不同的方法调用指定的功能。
- data.param：\`hwohBridgeCallNative\` 分发 \`opt\` 调用的方法时，js传递过来的参数信息。

4. 定义好参数后，可以调用引入的 \`dsbridge\` 中的 \`call\` 方法，其中第3个 \`function\` 参数是android java中执行完成后，回调到js的callback，返回执行结果信息。

具体示例代码如下：

\`\`\`javascript
hanldeDownload(ite){
  var params = {
    "handlerName": "hwohBridgeCallNative",
    "data": {
      "opt": "downloadApp",
      "param": {
        "url": ite.originalUrl,
        "name": ite.name,
        "packageName": ite.appPackage
      }
    }
  };

  dsBridge.call("hwohBridgeCallNative", params, function (ret, responseCallback) {
    let res = JSON.parse(ret);
    alert(res.body.successStatus);
    responseCallback("200");
  });
}
\`\`\`

5. 在 \`com/hwoh/watch/bridge/JsApi.java\` 代码中，会调用到入口函数 \`hwohBridgeCallNative\`。其中要重点关注 \`IGrabExecutor factory = new GrabFactory(context).getExecutor(parse);\` ，会返回 \`executor\`，每个 \`executor\` 对应js传的参数中的1个 \`data.opt\`。

\`\`\`java
@JavascriptInterface
public void hwohBridgeCallNative(Object args, CompletionHandler<String> handler) {
    Log.i(TAG, "JsApi::hwohBridgeCallNative ---------------------->");
    JavascriptCallNativeReqParam parse = GrabParser.parse(args);
    IGrabExecutor factory = new GrabFactory(context).getExecutor(parse);
    if (Objects.isNull(factory)) {
        JavascriptCallNativeResponse j = new JavascriptCallNativeResponse();
        JavascriptCallNativeBody body = new JavascriptCallNativeBody();
        body.setSuccessStatus(CallNativeResponseCodeEnum.CANOT_FIND.getCode());
        j.setBody(body);
        handler.complete(JsonUtils.toJson(j));
        return;
    }
    factory.senMessageToNative(parse, handler);
}
\`\`\`

6. 在 \`com/hwoh/watch/bridge/task/DownloadAppExecutor.java\` 中，继承 \`AbstractGrabAbstractExecutor\` 基类实现对应 \`executor\` 具体的业务功能。

7. 如下图示例代码，执行完成业务后，将结果信息以 \`json\` 格式设置到 \`body\` ，通过 \`handler.complete\` 回调到js中。

![](assets/3.png)
<img src="${docImg13}" alt="" style="max-width: 100%;">

8. 将实现好的 \`Executor\` 注册到 \`GrabFactory\` 中， 在调用 \`hwohBridgeCallNative\` 时，调用 \`getExecutor\` 进会根据 \`data.opt\` 中的opt来获取指定的 \`executor\` 执行具体业务。具体代码如下：

\`\`\`java
public enum CallNativeMethodEnum {
    ......
    DOWNLOAD_APP("downloadApp"),
    GET_APP_INSTALL_STATUS("getAppInstallStatus");
    ......
}


public class GrabFactory {

    private final Map<String, AbstractGrabAbstractExecutor> factory = new HashMap<>();

    public GrabFactory(Activity context) {
        factory.put(CallNativeMethodEnum.Download_APP.value(), new DownloadAppExecutor(context));
        factory.put(CallNativeMethodEnum.GET_APP_INSTALL_STATUS.value(), new GetAppInstallStatusExecutor(context));
    }

    public IGrabExecutor getExecutor(JavascriptCallNativeReqParam reqParam) {
        if (null == reqParam || Objects.isNull(reqParam.getData().getOpt())) {
            return null;
        }
        return factory.get(reqParam.getData().getOpt());
    }
}
\`\`\`

9. 其它业务的 \`executor\` 可以参考 \`DownloadAppExecutor\` 的实现。

## Java调用H5中Javascript

### 接口定义

社区提供了应用市场的Javascript的接口，开发者可以先了解有哪些接口及具体功能。

接口定义链接：[点我查看](##8.HWOHBridge接口)。

### 调用流程

当前Android上的应用市场是以 \`webview\` 来显示呈现的，java要调用js时，要先获取到 \`webview\` 的一个实例。目前是用 \`DWebView\` 封装 \`webview\` 来实现具体的功能。

1. 在布局文件中添加 \`DWebView\` 组件。

2. 在代码中获取 \`DWebView\` 实例，在业务需要的地方调用 \`callHandler\` 函数，其函数原型：\`public synchronized <T> void callHandler(String method, Object[] args, final OnReturnValue<T> handler)\` ，参数含义：

- method：js中提供的方法，需要android开发与H5开发约定定义。
- args：java调用js方法时，传给js方法的参数，目前是以json格式传递。
- handler：js回调到java的方法，js方法执行完成后，会调用handler将结果回调给java。

3. 先执行具体的业务，将要传递的参数信息是json格式设置到response的body中，再调用 \`DWebView\` 实例的 \`callHandler\` 函数。

4. 如下面示例代码，是在下载watch应用安装包的过程中，将下载进度通过js提供的 \`onDownloadProgress\` 函数回调到H5页面去展示。

具体示例代码如下：

\`\`\`java
JsonObject object = new JsonObject();
object.addProperty("name", name);
object.addProperty("packageName", packageName);
object.addProperty("progress", progress);

NativeCallJavascriptResponse r = new NativeCallJavascriptResponse();
r.setBody(object);
Log.i(TAG, "onProgress body:" + JsonUtils.toJson(r));
dWebview.callHandler("onDownloadProgress", new Object[]{JsonUtils.toJson(r)}, new OnReturnValue<String>() {
    @Override
    public void onValue(String retValue) {
        Log.i(TAG, "CallJavascript---->onValue:" + retValue);
    }
});
\`\`\`

## 注意事项

### 权限问题

开发时会需要存储，网络，蓝牙等权限，在 \`AndroidManifest.xml\` 中申明，在需要权限的操作前，最好动态检查和申请，建议使用 \`EasyPermissions\`，\`RxPermissions\` 等权限管理工具。

### 线程问题

执行长时任务时，不要在UI线程执行，建议使用 \`RxAndroid\` 等库来调度线程的切换。

### 接口定义问题

目前社区示例中不管是js还是android提供的接口都比较少，只需H5开发与android开发约定好接口格式参数，按流程添加即可:

js新增接口给android调用：

1. js增加业务接口实现。
2. 在android中，用DWebview实例调用callHandler去call js新增的接口。

android新增接口给js调用：

1. android中创建类继承AbstractGrabAbstractExecutor，实现具体的业务功能。
2. 在CallNativeMethodEnum类中添加定义，将提供给js的opt与androidr业务类绑定。
3. 在GrabFactory中注册上一步创建的业务类。
4. js通过设置opt到参数中，来调用hwohBridgeCallNative，最终调用到android对应的业务类中。

## HWOHBridge接口

WatchConnectKit-JsBridge Native 和 H5 交互协议文档。

### 版本更新

bridgeVersion：1

### 错误码

需要用户授权功能，拒绝时的错误码

| 错误编号 | 错误说明         |
| :------- | :--------------- |
| 5000     | 没有找到相应配置 |

### User-Agent设置

#### 格式

\`\`\`js
<Browser User-Agent><Space><SDK Identifier><SDK Version>
\`\`\`

#### 参数

| 参数               | 说明                     |
| :----------------- | :----------------------- |
| Browser User-Agent | 浏览器内核默认User-Agent |
| Space              | 英文半角空格             |
| SDK Identifier     | 统一使用：HWOH_BRIDGE    |
| SDK Version        | SDK版本号, 示例: 1       |

#### 示例

\`\`\`js
Chrome/61.0.3163.100 HWOH_BRIDGE/1
\`\`\`

### 加载H5页面

手机Native以webview组件加载H5，来加载和显示。

应用商店h5页面url: **https://www.openwearplay.com/watch/app**。

1. 参数信息

| 参数名称         | 类型   | 描述                                          | 是否必传 |
| :--------------- | :----- | :-------------------------------------------- | :------- |
| vendorIdentity   | String | 整机厂商id, 如:xxx-zzz-yyy                    | 是       |
| deviceSn         | String | 设备序列号, 如:xxx-zzz-yyy                    | 是       |
| consumerIdentity | String | 消费者用户唯一标识, 如:xxx-zzz-yyy            | 是       |
| consumerType     | String | 消费者用户类型                                | 是       |
| themeMode        | String | H5页面主题, 模式:light(浅色)(默认)/dark(深色) | 是       |
| phoneOs          | String | 手机系统，取值：Android/iOS/HarmonyOS          | 是       |
| watchOsVersion   | String | 由品牌商定义的watch系统版本号，格式：xx.yy.zzz，取值规则：xx: 0->99，yy：0->99，zzz：0->999          | 是       |
| chipPlatform     | String | 芯片平台，如：hisi                            | 是       |
| chipModel        | String | 芯片型号, 如：300                             | 是       |
| os               | String | watch系统,如: openharmony等                   | 是       |
| osVersion        | String | watch系统版本,如: 5.0.1                       | 是       |
| sdkVersion       | String | sdk版本号,如: 13                              | 是       |
| resolution       | String | watch分辨率,格式：宽\\*高,如:466\\*466          | 是       |
说明：其中 **vendorIdentity**，**consumerIdentity**，**consumerType**，**deviceSn** 需要到 **OpenHarmony智能穿戴聚合平台** 注册获取，注册地址：**https://www.openwearplay.com/ums**

2. 加载示例

\`\`\`java

// 模拟从表端设备获取系统信息
WatchSystemInfo info = new WatchSystemInfo("hisi", "3321", "openharmony", "5.0.1", "13","3.2", "466*466");

DWebView.setWebContentsDebuggingEnabled(true);
dWebView.addJavascriptObject(new JsApi(this), null);
dWebView.setDWebViewListener(new DWebView.DWebViewListener() {
    @Override
    public void onPageFinished() {
        JsonObject object = new JsonObject();
        object.addProperty("vendorIdentity", "xxxxx");
        object.addProperty("consumerIdentity", "yyyyy");
        object.addProperty("consumerType", 0);
        object.addProperty("deviceSn", "xxx-yyy-zzz");
        object.addProperty("themeMode", "light");
        object.addProperty("phoneOs", "Android");
        object.addProperty("watchOsVersion", "3.11.110");
        object.addProperty("chipPlatform", info.getChipPlatform());
        object.addProperty("chipModel", info.getChipModel());
        object.addProperty("os", info.getOs());
        object.addProperty("osVersion", info.getOsVersion());
        object.addProperty("sdkVersion", info.getSdkVersion());
        object.addProperty("resolution", info.getResolution());
        String js = "localStorage.setItem('watch_app_store_params', '" + object + "');";
        dWebView.evaluateJavascript(js, null);
        Object[] args = new Object[]{Utils.json()};
        dWebView.callHandler("updateAppInstallStatus", args, new OnReturnValue<String>() {
            @Override
            public void onValue(String retValue) {
            }
        });
    }
});
String url = "https://www.openwearplay.com/watch/app";
dWebView.loadUrl(url);
\`\`\`

### Native接口定义

目前Native提供 **hwohBridgeCallNative** 作为JS调用Navtive的唯一接口，以参数中的 **opt** 来标识Native执行不同的业务功能。

#### hwohBridgeCallNative接口

1. 参数信息

| 参数名称    | 类型       | 描述                                 | 是否必传 |
| :---------- | :--------- | :----------------------------------- | :------- |
| handlerName | String     | 调用名称：hwohBridgeCallNative       | 是       |
| data        | JsonObject | 调用参数                             | 是       |
| - opt       | String     | 方法名称，参见接口列表               | 是       |
| - param     | JsonObject | opt的参数，根据opt提供的方法确定格式 | 是       |

示例：

\`\`\`json
{
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "getAppInstallStatus",
        "param": {}
    }
}
\`\`\`

2. 响应数据

JS调Native方法后，Native提供的响应数据。

| 参数名称        | 类型       | 描述                                     | 是否必传 |
| :-------------- | :--------- | :--------------------------------------- | :------- |
| body            | JsonObject | 返回给js的业务数据，根据不同的业务来确定 | 是       |
| common          | JsonObject | 公共参数，所有方法的回调都有             | 是       |
| - appId         | String     | appId,如：xxx.xxx.xxx.xxx                | 是       |
| - bridgeVersion | String     | bridge框架的版本号  如：1                | 是       |
| - version       | String     | APP版本名称 如：1.0.0                    | 是       |
| - versionCode   | String     | APP版本号 如：1                          | 是       |
| - pid           | String     | 设备号，Android：IMIE，可能为空          | 是       |
| - os            | String     | 操作类型：Android                        | 是       |
| - sysVersion    | String     | 操作系统版本  如：8.0                    | 是       |
| - deviceModel   | String     | 设备型号  如：RedMi                      | 是       |
| - manufacturer  | String     | 设备制造商                               | 是       |
| - channel       | String     | 渠道，目前有两种：haisi，hengxuan        | 是       |
| - netWorkType   | String     | 网络类型：2g,3g,4g,wifi                  | 是       |

示例

\`\`\`json
{
    "body": [
        {
            "name": "xxxApp",
            "packageName": "com.watch.xxxApp",
            "status": 0
        }
    ],
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "hengxuan",
        "deviceModel": "Android SDK built for x86",
        "manufacturer": "Google",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

3. js调用hwohBridgeCallNative示例

\`\`\`js
var params = {
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "getAppInstallStatus",
        "param": {}
    }
};

dsBridge.call("hwohBridgeCallNative", params, function (ret, responseCallback) {
    let res = JSON.parse(ret);
    console.log("hwohBridgeCallNative==",res);
    responseCallback("200");
});
\`\`\`

### Native接口列表(参数opt值)

**opt** 是Native提供的功能名称。

| opt字段值           | 功能描述                    |
| :------------------ | :-------------------------- |
| getAppInstallStatus | 获取watch设备应用的安装状态 |
| downloadApp         | 下载watch应用               |
| installApp          | 安装watch应用               |
| uninstallApp        | 卸载watch应用               |

目前android提供了以上功能给javascript调用。

#### 获取watch设备应用的安装状态

1. 接口名称：getAppInstallStatus

2. 参数信息

| 参数名称    | 类型       | 描述                                 | 是否必传 |
| :---------- | :--------- | :----------------------------------- | :------- |
| handlerName | String     | 调用名称：hwohBridgeCallNative       | 是       |
| data        | JsonObject | 调用参数                             | 是       |
| - opt       | String     | 方法名称，参见接口列表               | 是       |
| - param     | JsonObject | opt的参数，根据opt提供的方法确定格式 | 是       |

调用时，整个json对象为 \`hwohBridgeCallNative\` 的参数，\`data\` 中的 \`param\` 为 \`opt\` 的参数，其中 **opt** 为 **getAppInstallStatus** 时，无参数，传递的 \`param\` 为空的json对象。

示例：

\`\`\`json
{
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "getAppInstallStatus",
        "param": {}
    }
}
\`\`\`

3. Native返回给js的响应格式

| 参数名称      | 类型            | 描述                                                    | 是否必传 |
| :------------ | :-------------- | :------------------------------------------------------ | :------- |
| body          | JsonObject List |                                                         | 是       |
| - name        | String          | 应用名称                                                | 是       |
| - packageName | String          | 应用包名(e.g.: com.xxx.aa)                              | 是       |
| - status      | String          | 安装状态：0：未安装；10：已安装；20：安装中；30：卸载中 | 是       |
| common        | JsonObject      | 见：接口响应数据common                                  | 是       |

示例：

\`\`\`json
{
    "body": [
        {
            "name": "HealthApp",
            "packageName": "com.xxx.HealthApp",
            "status": 0
        },
        {
            "name": "MusicApp",
            "packageName": "com.xxx.MusicApp",
            "status": 20
        }
    ],
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "haisi",
        "deviceModel": "PHY110",
        "manufacturer": "OPPO",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

4. js调用getAppInstallStatus示例

\`\`\`js
var params = {
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "getAppInstallStatus",
        "param": {}
    }
};

dsBridge.call("hwohBridgeCallNative", params, function (ret, responseCallback) {
    let res = JSON.parse(ret);
    console.log("hwohBridgeCallNative==",res);
    responseCallback("200");
});
\`\`\`

#### 下载watch应用

1. 接口名称：downloadApp

2. 参数信息

| 参数名称       | 类型       | 描述                           | 是否必传 |
| :------------- | :--------- | :----------------------------- | :------- |
| handlerName    | String     | 调用名称：hwohBridgeCallNative | 是       |
| data           | JsonObject | 调用参数                       | 是       |
| - opt          | String     | 方法名称，参见接口列表         | 是       |
| - param        | JsonObject | opt的参数                      | 是       |
| -- packageName | String     | 应用包名                       | 是       |
| -- appName     | String     | 应用名称                       | 是       |
| -- fileName    | String     | 应用的下载文件名               | 是       |
| -- url         | String     | 应用的下载地址                 | 是       |

调用时，整个json对象为 \`hwohBridgeCallNative\` 的参数，\`data\` 中的 \`param\` 为 \`opt\` 的参数，其中 **opt** 为 **downloadApp** 时，传递 \`param\` 的json对象。

示例：

\`\`\`json
{
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "downloadApp",
        "param": {
            "packageName": "com.xxxApp.watch",
            "appName": "xxxApp",
            "fileName": "xxxApp.bin",
            "url": "https://www.xxx.com/xxxApp.bin"
        }
    }
}
\`\`\`

3. Native返回给js的响应格式

| 参数名称        | 类型       | 描述             | 是否必传 |
| :-------------- | :--------- | :--------------- | :------- |
| body            | JsonObject |                  | 是       |
| - successStatus | String     | 是否开始下载任务 | 是       |

示例：

\`\`\`json
{
    "body": {
        "successStatus": "1"
    }
}
\`\`\`

4. js调用downloadApp示例

\`\`\`js
var params = {
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "downloadApp",
        "param": {
            "packageName": "com.xxxApp.watch",
            "appName": "xxxApp",
            "fileName": "xxxApp.bin",
            "url": "https://www.xxx.com/xxxApp.bin"
        }
    }
};

dsBridge.call("hwohBridgeCallNative", params, function (ret, responseCallback) {
    let res = JSON.parse(ret);
    console.log("hwohBridgeCallNative==",res);
    responseCallback("200");
});
\`\`\`

#### 安装watch应用

1. 接口名称：installApp

2. 参数信息

| 参数名称       | 类型       | 描述                           | 是否必传 |
| :------------- | :--------- | :----------------------------- | :------- |
| handlerName    | String     | 调用名称：hwohBridgeCallNative | 是       |
| data           | JsonObject | 调用参数                       | 是       |
| - opt          | String     | 方法名称，参见接口列表         | 是       |
| - param        | JsonObject | opt的参数                      | 是       |
| -- packageName | String     | 应用包名                       | 是       |
| -- appName     | String     | 应用名称                       | 是       |
| -- fileName    | String     | 应用的下载文件名               | 是       |
| -- url         | String     | 应用的下载地址                 | 是       |

调用时，整个json对象为 \`hwohBridgeCallNative\` 的参数，\`data\` 中的 \`param\` 为 \`opt\` 的参数，其中 **opt** 为 **installApp** 时，传递 \`param\` 的json对象。

示例：

\`\`\`json
{
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "installApp",
        "param": {
            "packageName": "com.xxxApp.watch",
            "appName": "xxxApp",
            "fileName": "xxxApp.bin",
            "url": "https://www.xxx.com/xxxApp.bin"
        }
    }
}
\`\`\`

3. Native返回给js的响应格式

| 参数名称        | 类型       | 描述             | 是否必传 |
| :-------------- | :--------- | :--------------- | :------- |
| body            | JsonObject |                  | 是       |
| - successStatus | String     | 是否开始下载任务 | 是       |

示例：

\`\`\`json
{
    "body": {
        "successStatus": "1"
    }
}
\`\`\`

4. js调用installApp示例

\`\`\`js
var params = {
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "installApp",
        "param": {
            "packageName": "com.xxxApp.watch",
            "appName": "xxxApp",
            "fileName": "xxxApp.bin",
            "url": "https://www.xxx.com/xxxApp.bin"
        }
    }
};

dsBridge.call("hwohBridgeCallNative", params, function (ret, responseCallback) {
    let res = JSON.parse(ret);
    console.log("hwohBridgeCallNative==",res);
    responseCallback("200");
});
\`\`\`

#### 卸载watch应用

1. 接口名称：uninstallApp

2. 参数信息

| 参数名称       | 类型       | 描述                           | 是否必传 |
| :------------- | :--------- | :----------------------------- | :------- |
| handlerName    | String     | 调用名称：hwohBridgeCallNative | 是       |
| data           | JsonObject | 调用参数                       | 是       |
| - opt          | String     | 方法名称，参见接口列表         | 是       |
| - param        | JsonObject | opt的参数                      | 是       |
| -- packageName | String     | 应用包名                       | 是       |
| -- appName     | String     | 应用名称                       | 是       |

调用时，整个json对象为 \`hwohBridgeCallNative\` 的参数，\`data\` 中的 \`param\` 为 \`opt\` 的参数，其中 **opt** 为 **uninstallApp** 时，传递 \`param\` 的json对象。

示例：

\`\`\`json
{
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "uninstallApp",
        "param": {
            "packageName": "com.xxxApp.watch",
            "appName": "xxxApp",
        }
    }
}
\`\`\`

3. Native返回给js的响应格式

| 参数名称        | 类型       | 描述             | 是否必传 |
| :-------------- | :--------- | :--------------- | :------- |
| body            | JsonObject |                  | 是       |
| - successStatus | String     | 是否开始下载任务 | 是       |

示例：

\`\`\`json
{
    "body": {
        "successStatus": "1"
    }
}
\`\`\`

4. js调用installApp示例

\`\`\`js
var params = {
    "handlerName": "hwohBridgeCallNative",
    "data": {
        "opt": "uninstallApp",
        "param": {
            "packageName": "com.xxxApp.watch",
            "appName": "xxxApp",
        }
    }
};

dsBridge.call("hwohBridgeCallNative", params, function (ret, responseCallback) {
    let res = JSON.parse(ret);
    console.log("hwohBridgeCallNative==",res);
    responseCallback("200");
});
\`\`\`

### Javascript接口

目前js提供了以下功能给android调用。

| 接口名称               | 功能描述                          |
| :--------------------- | :-------------------------------- |
| updateAppInstallStatus | 更新页面上watch设备应用的安装状态 |
| onDownloadProgress     | 应用下载的进度                    |
| onDownloadComplete     | 应用下载的结果                    |
| onInstallAppResult     | 应用安装的结果                    |
| onUninstallAppResult   | 应用卸载的结果                    |
| changeThemeMode        | 切换H5页面主题                    |

#### 更新应用安装状态

1. 接口名称：updateAppInstallStatus

2. 参数信息

| 参数名称      | 类型            | 描述                                                    | 是否必传 |
| :------------ | :-------------- | :------------------------------------------------------ | :------- |
| body          | JsonObject List |                                                         | 是       |
| - name        | String          | 应用名称                                                | 是       |
| - packageName | String          | 应用包名(e.g.: com.xxx.aa)                              | 是       |
| - status      | String          | 安装状态：0：未安装；10：已安装；20：安装中；30：卸载中 | 是       |
| common        | JsonObject      | 见：接口响应数据common                                  | 是       |

示例：

\`\`\`json
{
    "body": [
        {
            "name": "validator",
            "packageName": "com.examplemini.actsvalidator",
            "status": 10
        },
        {
            "name": "xxxApp",
            "packageName": "com.watch.xxxApp",
            "status": 20
        },
        {
            "name": "testValidator",
            "packageName": "com.test.testValidator",
            "status": 30
        }
    ],
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "hengxuan",
        "deviceModel": "Android SDK built for x86",
        "manufacturer": "Google",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

3. Js返回给Native的响应格式

| 参数名称 | 类型   | 描述      | 是否必传 |
| :------- | :----- | :-------- | :------- |
| data     | String | js 响应码 | 是       |

示例：

\`\`\`json
{
    "data": "200"
}
\`\`\`

4. Native调用updateAppInstallStatus示例

先构建参数，在获取到 \`DWebView\` 的实例后，调用 \`callHandler\` ，传入参数。

\`\`\`java
private String json() {
    List<AppInfo> l = new ArrayList<>();
    AppInfo app = new AppInfo();
    app.setName("validator");
    app.setPackageName("com.examplemini.actsvalidator");
    app.setStatus(10);
    l.add(app);

    app = new AppInfo();
    app.setName("xxxApp");
    app.setPackageName("com.watch.xxxApp");
    app.setStatus(0);
    l.add(app);

    app = new AppInfo();
    app.setName("testValidator");
    app.setPackageName("com.test.testValidator");
    app.setStatus(0);
    l.add(app);

    NativeCallJavascriptResponse r = new NativeCallJavascriptResponse();
    r.setBody(l);
    return JsonUtils.toJson(r);
}

@Override
public void senMessageToNative(JavascriptCallNativeReqParam reqParam, CompletionHandler<String> handler) {
    dWebView().callHandler("updateAppInstallStatus", new Object[]{json()}, new OnReturnValue<String>() {
        @Override
        public void onValue(String retValue) {
            Log.i(TAG, "updateAppInstallStatus, onValue:" + retValue);
        }
    });
}
\`\`\`

#### 应用下载的进度

1. 接口名称：onDownloadProgress

2. 参数信息

| 参数名称      | 类型            | 描述                       | 是否必传 |
| :------------ | :-------------- | :------------------------- | :------- |
| body          | JsonObject List |                            | 是       |
| - name        | String          | 应用名称                   | 是       |
| - packageName | String          | 应用包名(e.g.: com.xxx.aa) | 是       |
| - progress    | int             | 下载进度，取值：0 ~ 100    | 是       |
| common        | JsonObject      | 见：接口响应数据common     | 是       |

示例：

\`\`\`json
{
    "body": {
        "name": "xxxApp",
        "packageName": "com.watch.xxxApp",
        "progress": 98
    },
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "haisi",
        "deviceModel": "Android SDK built for x86",
        "manufacturer": "Google",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

3. Js返回给Native的响应格式

| 参数名称 | 类型   | 描述      | 是否必传 |
| :------- | :----- | :-------- | :------- |
| data     | String | js 响应码 | 是       |

示例：

\`\`\`json
{
    "data": "200"
}
\`\`\`

4. Native调用onDownloadProgress示例

先构建参数，在获取到 \`DWebView\` 的实例后，调用 \`callHandler\` ，传入参数。

\`\`\`java
JsonObject object = new JsonObject();
object.addProperty("name", reqParam.getData().getParam().getName());
object.addProperty("packageName", reqParam.getData().getParam().getPackageName());
object.addProperty("progress", progress);

NativeCallJavascriptResponse r = new NativeCallJavascriptResponse();
r.setBody(object);
dWebView().callHandler("onDownloadProgress", new Object[]{JsonUtils.toJson(r)}, new OnReturnValue<String>() {
    @Override
    public void onValue(String retValue) {
        Log.i(TAG, "onDownloadProgress, onValue:" + retValue);
    }
});
\`\`\`

#### 应用下载的结果

1. 接口名称：onDownloadComplete

2. 参数信息

| 参数名称      | 类型            | 描述                               | 是否必传 |
| :------------ | :-------------- | :--------------------------------- | :------- |
| body          | JsonObject List |                                    | 是       |
| - name        | String          | 应用名称                           | 是       |
| - packageName | String          | 应用包名(e.g.: com.xxx.aa)         | 是       |
| - code        | int             | 下载结果码，0：正常完成，非0：出错 | 是       |
| - message     | String          | 出错时，错误提示信息               | 是       |
| common        | JsonObject      | 见：接口响应数据common             | 是       |

示例：

\`\`\`json
{
    "body": {
        "name": "xxxApp",
        "packageName": "com.watch.xxxApp",
        "code": 0,
        "message": "Download success!!"
    },
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "haisi",
        "deviceModel": "Android SDK built for x86",
        "manufacturer": "Google",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

3. Js返回给Native的响应格式

| 参数名称 | 类型   | 描述      | 是否必传 |
| :------- | :----- | :-------- | :------- |
| data     | String | js 响应码 | 是       |

示例：

\`\`\`json
{
    "data": "200"
}
\`\`\`

4. Native调用onDownloadComplete示例

先构建参数，在获取到 \`DWebView\` 的实例后，调用 \`callHandler\` ，传入参数。

\`\`\`java
JsonObject object = new JsonObject();
object.addProperty("name", reqParam.getData().getParam().getName());
object.addProperty("packageName", reqParam.getData().getParam().getPackageName());
object.addProperty("code", code);
object.addProperty("message", msg);

NativeCallJavascriptResponse r = new NativeCallJavascriptResponse();
r.setBody(object);
dWebView().callHandler("onDownloadComplete", new Object[]{JsonUtils.toJson(r)}, new OnReturnValue<String>() {
    @Override
    public void onValue(String retValue) {
        Log.i(TAG, "onDownloadComplete, onValue:" + retValue);
    }
});
\`\`\`

#### 应用安装的结果

1. 接口名称：onInstallAppResult

2. 参数信息

| 参数名称      | 类型            | 描述                               | 是否必传 |
| :------------ | :-------------- | :--------------------------------- | :------- |
| body          | JsonObject List |                                    | 是       |
| - name        | String          | 应用名称                           | 是       |
| - packageName | String          | 应用包名(e.g.: com.xxx.aa)         | 是       |
| - code        | int             | 安装结果码，0：正常安装，非0：出错 | 是       |
| - message     | String          | 出错时，错误提示信息               | 是       |
| common        | JsonObject      | 见：接口响应数据common             | 是       |

示例：

\`\`\`json
{
    "body": {
        "name": "xxxApp",
        "packageName": "com.watch.xxxApp",
        "code": 0,
        "message": "Install success!!"
    },
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "haisi",
        "deviceModel": "Android SDK built for x86",
        "manufacturer": "Google",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

3. Js返回给Native的响应格式

| 参数名称 | 类型   | 描述      | 是否必传 |
| :------- | :----- | :-------- | :------- |
| data     | String | js 响应码 | 是       |

示例：

\`\`\`json
{
    "data": "200"
}
\`\`\`

4. Native调用onInstallAppResult示例

先构建参数，在获取到 \`DWebView\` 的实例后，调用 \`callHandler\` ，传入参数。

\`\`\`java
JsonObject object = new JsonObject();
object.addProperty("name", reqParam.getData().getParam().getName());
object.addProperty("packageName", reqParam.getData().getParam().getPackageName());
object.addProperty("code", code);
object.addProperty("message", msg);

NativeCallJavascriptResponse r = new NativeCallJavascriptResponse();
r.setBody(object);
dWebView().callHandler("onInstallAppResult", new Object[]{JsonUtils.toJson(r)}, new OnReturnValue<String>() {
    @Override
    public void onValue(String retValue) {
        Log.i(TAG, "onInstallAppResult, onValue:" + retValue);
    }
});
\`\`\`

#### 应用卸载的结果

1. 接口名称：onUninstallAppResult

2. 参数信息

| 参数名称      | 类型            | 描述                               | 是否必传 |
| :------------ | :-------------- | :--------------------------------- | :------- |
| body          | JsonObject List |                                    | 是       |
| - name        | String          | 应用名称                           | 是       |
| - packageName | String          | 应用包名(e.g.: com.xxx.aa)         | 是       |
| - code        | int             | 卸载结果码，0：正常卸载，非0：出错 | 是       |
| - message     | String          | 出错时，错误提示信息               | 是       |
| common        | JsonObject      | 见：接口响应数据common             | 是       |

示例：

\`\`\`json
{
    "body": {
        "name": "xxxApp",
        "packageName": "com.watch.xxxApp",
        "code": 0,
        "message": "Uninstall success!!"
    },
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "haisi",
        "deviceModel": "Android SDK built for x86",
        "manufacturer": "Google",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

3. Js返回给Native的响应格式

| 参数名称 | 类型   | 描述      | 是否必传 |
| :------- | :----- | :-------- | :------- |
| data     | String | js 响应码 | 是       |

示例：

\`\`\`json
{
    "data": "200"
}
\`\`\`

4. Native调用onUninstallAppResult示例

先构建参数，在获取到 \`DWebView\` 的实例后，调用 \`callHandler\` ，传入参数。

\`\`\`java
JsonObject object = new JsonObject();
object.addProperty("name", reqParam.getData().getParam().getName());
object.addProperty("packageName", reqParam.getData().getParam().getPackageName());
object.addProperty("code", code);
object.addProperty("message", msg);

NativeCallJavascriptResponse r = new NativeCallJavascriptResponse();
r.setBody(object);
dWebView().callHandler("onUninstallAppResult", new Object[]{JsonUtils.toJson(r)}, new OnReturnValue<String>() {
    @Override
    public void onValue(String retValue) {
        Log.i(TAG, "onUninstallAppResult, onValue:" + retValue);
    }
});
\`\`\`

#### 切换H5页面主题

1. 接口名称：changeThemeMode

2. 参数信息

| 参数名称 | 类型            | 描述                              | 是否必传 |
| :------- | :-------------- | :-------------------------------- | :------- |
| body     | JsonObject List |                                   | 是       |
| - mode   | String          | 模式:light(浅色)(默认)/dark(深色) | 是       |
| common   | JsonObject      | 见：接口响应数据common            | 是       |

示例：

\`\`\`json
{
    "body": {
        "mode": "dark"
    },
    "common": {
        "appId": "appId",
        "bridgeVersion": "1",
        "channel": "haisi",
        "deviceModel": "Android SDK built for x86",
        "manufacturer": "Google",
        "netWorkType": "2g",
        "os": "Android",
        "pid": "adasdsdsasd",
        "sysVersion": "1.10",
        "version": "1.0",
        "versionCode": "101"
    }
}
\`\`\`

3. Js返回给Native的响应格式

| 参数名称 | 类型   | 描述      | 是否必传 |
| :------- | :----- | :-------- | :------- |
| data     | String | js 响应码 | 是       |

示例：

\`\`\`json
{
    "data": "200"
}
\`\`\`

4. Native调用changeThemeMode示例

先构建参数，在获取到 \`DWebView\` 的实例后，调用 \`callHandler\` ，传入参数。

\`\`\`java
JsonObject object = new JsonObject();
object.addProperty("mode", "dark"); // 模式:light(浅色)/dark(深色)

NativeCallJavascriptResponse r = new NativeCallJavascriptResponse();
r.setBody(object);
dWebView().callHandler("changeThemeMode", new Object[]{JsonUtils.toJson(r)}, new OnReturnValue<String>() {
    @Override
    public void onValue(String retValue) {
        Log.i(TAG, "changeThemeMode, onValue:" + retValue);
    }
});
\`\`\`

### 接口开发示例Demo

目前社区已经提供了接口相关的开发demo，供开发者参考。

Demo地址：[点我查看](https://gitee.com/cooperation-team-L0UI/watch-app-store/blob/master/app_store/watch-app-store-dev-android.md)。

### 自定义接口定义

目前社区中不管是js还是android提供的接口功能都较少，如需要新的功能接口，可自行定义，只需H5开发与android开发约定好接口格式参数，按流程添加即可:

js新增接口给android调用：

1. js增加业务接口实现。
2. 在android中，用DWebview实例调用callHandler去call js新增的接口。

android新增接口给js调用：

1. android中创建类继承AbstractGrabAbstractExecutor，实现具体的业务功能。
2. 在CallNativeMethodEnum类中添加定义，将提供给js的opt与androidr业务类绑定。
3. 在GrabFactory中注册上一步创建的业务类。
4. js通过设置opt到参数中，来调用hwohBridgeCallNative，最终调用到android对应的业务类中。
    `,
    // children: [
    //   {
    //     id: 31,
    //     label: "概述",
    //     path: "/device/market-overview",
    //     data: ``,
    //   },
    // ],
  },
];
